// extracted by mini-css-extract-plugin
export default {"container":"NotificationButton_container__pBrxX","icon":"NotificationButton_icon__5M-EQ","loading":"NotificationButton_loading__7OzKG"};